import type Asset from '../asset';
import { FilterJSON, isFileTypeFilterJSON, FileType } from './types';
import FilterOption from './filterOption';

export default class FileTypeFilter implements FilterOption {
	fileType: FileType;

	constructor( fileType: FileType ) {
		this.fileType = fileType;
	}

	get id() {
		return `file-type-${this.fileType}`;
	}

	get filterAmount() {
		return 1;
	}

	isPassedBy( asset: Asset ) {
		if ( this.fileType === 'image' ) {
			return asset.isImage;
		}
		// 'doc' corresponds to document assets
		return asset.isDocument;
	}

	toJson() {
		return { type: this.fileType };
	}

	static fromJson( json: FilterJSON ) {
		return isFileTypeFilterJSON( json )
			? new FileTypeFilter( json.type )
			: null;
	}
}
